import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-standard-page-content',
  templateUrl: 'standard-page-content.component.html',
  styleUrls: ['standard-page-content.component.scss'],
  standalone: false,
})
export class StandardPageContentComponent {
  @Input() limitWidth = false;
  // Wider max-width cap for data-heavy pages (grids/tables/card galleries) — only
  // meaningful alongside limitWidth; see .container-wide in 3-components/_content.scss.
  @Input() wide = false;
  @Input() flexGrow = false;

  @HostBinding('class') get cssClass() {
    return (
      'card vertical' +
      (this.limitWidth ? ` ms-0 ${this.wide ? 'container-wide' : 'container'} p-0` : '') +
      (this.flexGrow ? ' flex-grow-1' : '') +
      this.customCssClass
    );
  }

  private customCssClass = '';

  constructor(private cd: ChangeDetectorRef) {}

  addCssClass(cssClass: string) {
    if (!new RegExp(` ${cssClass}( |$)`).test(this.customCssClass)) {
      setTimeout(() => {
        this.customCssClass += ' ' + cssClass;
        this.cd.markForCheck();
      });
    }
  }
}
